import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button, Spinner } from "react-bootstrap";
import Sample14 from "../Components/Logo";
import { useAuth } from "../Context/AuthContext";
import { Base_URL } from "../url";
import { fetchCompnayCodesById } from "../Api/InvoiceApi";
import axios from "axios";
import { toast } from "react-toastify";

const LABOUR_TYPES = ["Supervisor", "Manager", "Labour"];
const DURATION_UNITS = ["H", "Days", "Weeks", "Months", "Years"];

const emptySubProcess = (defaultStationId = "") => ({
  processName: "",
  productionStationId: defaultStationId,
  approxDuration: "",
  approxDurationUnit: DURATION_UNITS[0],
  labourType: LABOUR_TYPES[0],
  duration: "",
  durationUnit: DURATION_UNITS[0],
});

const ProductionSubProcesses = () => {
  const { user } = useAuth();
  const orgId = user?.organisationId;

  const [loading, setLoading] = useState(false);
  const [dropdownLoading, setDropdownLoading] = useState(false);
  const [stations, setStations] = useState([]);
  const [companyCodes, setCompanyCodes] = useState([]);
  const [companyCode, setCompanyCode] = useState("");

  const [subProcesses, setSubProcesses] = useState([emptySubProcess()]);

  useEffect(() => {
    const fetchLookups = async () => {
      setDropdownLoading(true);
      try {
        // company codes
        const companies = await fetchCompnayCodesById(orgId);
        setCompanyCodes(companies || []);
        if (companies && companies.length > 0) {
          const first = companies[0];
          const code = first.companyCode ?? first.code ?? first.value ?? first.id ?? first.CompanyCode;
          setCompanyCode(String(code));
        }

        // production stations
        const res = await fetch(`${Base_URL}/ProductionStation/id?id=${encodeURIComponent(orgId || "")}`);
       if (res.ok) {
  const data = await res.json();
  const arr = Array.isArray(data) ? data : [];

  // Filter unique productionStationId values
  const uniqueStations = arr.filter(
    (item, index, self) =>
      index === self.findIndex((t) => t.productionStationId === item.productionStationId)
  );

  setStations(uniqueStations);

  // Set default productionStationId for first subprocess if available
  const firstId = uniqueStations[0]?.productionStationId ?? null;
  setSubProcesses([emptySubProcess(firstId ?? "")]);
}

      } catch (err) {
        console.error("Error loading lookups", err);
      } finally {
        setDropdownLoading(false);
      }
    };

    fetchLookups();
  }, [orgId]);

  const handleSubChange = (index, e) => {
    const { name, value } = e.target;
    setSubProcesses((prev) => {
      const copy = [...prev];
      copy[index] = { ...copy[index], [name]: value };
      return copy;
    });
  };

  const addSubProcess = () => {
    const defaultStationId = stations[0]?.productionStationId?? "";
    setSubProcesses((p) => [...p, emptySubProcess(defaultStationId)]);
  };

  const removeSubProcess = (index) => {
    setSubProcesses((p) => p.filter((_, i) => i !== index));
  };

  const validate = () => {
    if (!companyCode) return "Select Company Code";
    if (!subProcesses || subProcesses.length === 0) return "No subprocesses to save";
    for (let i = 0; i < subProcesses.length; i++) {
      const s = subProcesses[i];
      if (!s.processName) return `Subprocess ${i + 1}: Enter process name`;
      if (!s.productionStationId) return `Subprocess ${i + 1}: Select production station`;
      // if (s.approxDuration === "") return `Subprocess ${i + 1}: Enter approximate duration`;
      // if (!s.approxDurationUnit) return `Subprocess ${i + 1}: Select approx duration unit`;
      // if (!s.labourType) return `Subprocess ${i + 1}: Select labour type`;
      // if (s.duration === "") return `Subprocess ${i + 1}: Enter duration`;
      // if (!s.durationUnit) return `Subprocess ${i + 1}: Select duration unit`;
    }
    return null;
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    const err = validate();
    if (err) return alert(err);

    const payload = {
      orgId,
      companyCode: Number(companyCode),
      createdBy: user?.userId ?? user?.organisationId ?? null,
      subProcesses: subProcesses.map((s) => ({
        name: s.processName,
        station: s.productionStationId,
      
      })),
    };
try {
  const res = await axios.post(`${Base_URL}/ProductionStation/CreateSubProcess`, payload);

  if (res.status === 200 || res.status === 201) {
    toast.success("Created Successfully");
  } else {
    toast.error("Error creating process");
  }
} catch (error) {
  console.error("Error creating subprocess:", error);
  toast.error("Error creating process");
}


    // reset form keeping default station selection
    const defaultStationId = stations[0]?.StationId ?? stations[0]?.stationId ?? stations[0]?.id ?? "";
    setSubProcesses([emptySubProcess(defaultStationId)]);
  };

  return (
    <div className="main-content expand">
      <Container fluid className="fields-container">
        <h3 className="fields-title">Production Sub-Processes</h3>

        <Form onSubmit={handleSubmit} className="fields-form">
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Company Code</Form.Label>
                <Form.Control as="select" value={companyCode} onChange={(e) => setCompanyCode(e.target.value)} disabled={dropdownLoading}>
                  <option value="">Select Company Code</option>
                  {companyCodes.map((c, i) => {
                    const val = c.companyCode ?? c.code ?? c.value ?? c.id ?? c.CompanyCode;
                    const label = c.name ?? c.companyName ?? c.label ?? String(val);
                    return <option key={i} value={String(val)}>{`${val} - ${label}`}</option>;
                  })}
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>

          {subProcesses.map((sub, idx) => (
            <div key={idx} className="border rounded p-3 mb-3">
              <Row className="align-items-end">
                <Col md={5}>
                  <Form.Group className="mb-3">
                    <Form.Label>Process Name</Form.Label>
                    <Form.Control name="processName" value={sub.processName} onChange={(e) => handleSubChange(idx, e)} />
                  </Form.Group>
                </Col>

                <Col md={5}>
                  <Form.Group className="mb-3">
                    <Form.Label>Production Station</Form.Label>
                    <Form.Control as="select" name="productionStationId" value={sub.productionStationId} onChange={(e) => handleSubChange(idx, e)} disabled={dropdownLoading}>
                      <option value="">Select Station</option>
                      {stations.map((s, i) => {
                        const id = s.productionStationId;
                        const label = s.productionStationDesc??s.StationName ?? s.stationName ?? s.name ?? s.Name ?? String(id);
                        return <option key={i} value={String(id)}>{s.productionStationId}-{label}</option>;
                      })}
                    </Form.Control>
                  </Form.Group>
                </Col>

                <Col md={2} className="text-end">
                  {subProcesses.length > 1 && (
                    <Button variant="danger" onClick={() => removeSubProcess(idx)}>Remove</Button>
                  )}
                </Col>
              </Row>

              {/* <Row>
                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Approx. Duration</Form.Label>
                    <Form.Control type="number" step="any" name="approxDuration" value={sub.approxDuration} onChange={(e) => handleSubChange(idx, e)} />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Approx. Duration Unit</Form.Label>
                    <Form.Control as="select" name="approxDurationUnit" value={sub.approxDurationUnit} onChange={(e) => handleSubChange(idx, e)}>
                      {DURATION_UNITS.map((u) => <option key={u} value={u}>{u}</option>)}
                    </Form.Control>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Labour Type</Form.Label>
                    <Form.Control as="select" name="labourType" value={sub.labourType} onChange={(e) => handleSubChange(idx, e)}>
                      {LABOUR_TYPES.map((l) => <option key={l} value={l}>{l}</option>)}
                    </Form.Control>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Duration</Form.Label>
                    <Form.Control type="number" step="any" name="duration" value={sub.duration} onChange={(e) => handleSubChange(idx, e)} />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Duration Unit</Form.Label>
                    <Form.Control as="select" name="durationUnit" value={sub.durationUnit} onChange={(e) => handleSubChange(idx, e)}>
                      {DURATION_UNITS.map((u) => <option key={u} value={u}>{u}</option>)}
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Row> */}
            </div>
          ))}

          <div className="d-flex gap-2 mb-3">
            <Button type="button" onClick={addSubProcess}>+ Add Sub-Process</Button>
            <Button variant="outline-secondary" type="button" onClick={() => {
              const defaultStationId = stations[0]?.StationId ?? stations[0]?.stationId ?? stations[0]?.id ?? "";
              setSubProcesses([emptySubProcess(defaultStationId)]);
            }}>Reset All</Button>
          </div>

          <div className="d-flex gap-2 mt-3">
            <Button type="submit" disabled={loading || dropdownLoading}>{loading ? (<><Spinner animation="border" size="sm" /> Saving...</>) : ("Save Sub-Processes")}</Button>

            <Button variant="secondary" type="button" onClick={() => {
              const defaultStationId = stations[0]?.StationId ?? stations[0]?.stationId ?? stations[0]?.id ?? "";
              setSubProcesses([emptySubProcess(defaultStationId)]);
            }}>Clear</Button>
          </div>
        </Form>
      </Container>

      {(loading || dropdownLoading) && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </div>
  );
};

export default ProductionSubProcesses;